module.exports = __webpack_public_path__ + "newWebTMS/img/forgot-password.c863b0af.png";